module.exports = __webpack_public_path__ + "static/media/webvision2.32099f40.png";